/**
 * 
 * key
 * 
 */


const key = 'Zm9sbG93dXBfc3RyYXRlZ3k='

export default key 